import { z } from "zod";
import { ProjectSchema } from "./Project";

export const CreateProjectRequestSchema = ProjectSchema.pick({
    accountId: true,
    name: true,
    lat: true,
    lng: true,
    description: true,
    ownerId: true,
    startDate: true,
    endDate: true
})

export type CreateProjectRequest = z.infer<typeof CreateProjectRequestSchema>;




